import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CdssApi, TPostExtubationResult, TPostHypotensionResult } from '../../services';
import { IExtubation, createExtubation } from '../cdss/extubation/Extubation';
import { IHypotension, createHypotension } from '../cdss/hypotension/Hypotension';
import { withEnvironment } from '../extensions/with-environment';
import { withRootStore } from '../extensions/with-root-store';
import { withSetPropAction } from '../extensions/withSetPropAction';
/**
 * # CdssStore
 *
 * CdssStore을 설명하세요.
 */
export const CdssStore = types
  .model('CdssStore')
  // --------------------------------------------------------------------------
  .props({
    hypotension: createHypotension(),
    extubation: createExtubation(),
    hypotensions: types.optional(types.array(createHypotension()), []),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .actions(withSetPropAction)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * cdsss을 교체
     *
     * @param `cdsss` 새로운 모델의 배열
     */

    setHypotension: (hypotension: IHypotension) => {
      self.hypotension = hypotension;
    },
    setHypotensions: (hypotensions: IHypotension[]) => {
      self.hypotensions.replace(hypotensions);
    },

    setExtubation: (extubation: IExtubation) => {
      self.extubation = extubation;
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청
  .actions((self) => ({
    /**
     * 전체 목록을 Api를 통해 조회
     *
     * 조회한 결과로 Cdsss를 교체한다. 실패시 에러 로그를 남긴다.
     */

    uploadAndGetExtubation: async (file: File) => {
      // API 호출 전 변수 초기화
      self.setExtubation({} as IExtubation);

      const cdssApi: CdssApi = new CdssApi(self.environment.api);
      const result: TPostExtubationResult = await cdssApi.uploadAndGetExtubation(file);
      if (result.kind === 'ok') {
        self.setExtubation(result.extubation);
      } else {
        const extubation: object = {
          detail: {
            errmsg: result.kind,
          },
        };
        self.setExtubation(extubation as IExtubation);
      }
    },

    uploadAndGetHypotension: async (file: File) => {
      // API 호출 전 변수 초기화
      try {
        // self.setHypotension({} as IHypotension);
        self.setHypotensions([] as IHypotension[]);
        const cdssApi: CdssApi = new CdssApi(self.environment.api);
        const result: TPostHypotensionResult = await cdssApi.uploadAndGetHypotension(file);

        if (
          self.rootStore.responseStore.getResponseResult(result) &&
          self.rootStore.responseStore.responseInfo.resultCode === 'S'
        ) {
          if (result.hypotensions) {
            self.setHypotensions(result.hypotensions);
          }
        }
      } catch (e) {
        self.rootStore.responseStore.errorProcessing(e);
      }
    },
  }));

// --------------------------------------------------------------------------
type TCdssStore = Instance<typeof CdssStore>;
type TCdssStoreSnapshot = SnapshotOut<typeof CdssStore>;

export interface ICdssStore extends TCdssStore {}
export type TCdssStoreKeys = keyof TCdssStoreSnapshot & string;
export interface ICdssStoreSnapshot extends TCdssStoreSnapshot {}
export const createCdssStore = () => types.optional(CdssStore, {} as TCdssStore);
